exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display[data-v-b1377baa]{padding:0 1rem;text-align:center}.display button[data-v-b1377baa]{width:175px}@media screen and (min-width: 1920px){.display button[data-v-b1377baa]{width:100%}}.display .display__title[data-v-b1377baa]{font-size:1rem}.display .display__info[data-v-b1377baa]{font-size:.7rem}", ""]);

// exports
